module.exports = __webpack_public_path__ + "img/mcertification.b3695b00.png";